import { ReportChartGroupItemMeasure } from '@vision/ui/interfaces';

export const EXCardChart1Measures: ReportChartGroupItemMeasure[] = [
  {
    type: 'feedback',
    items: [
      'feedback-count',
      'feedback-elc-score',
      'feedback-candidate-score',
      'feedback-nps',
      'feedback-sentiment-score',
      'feedback-csat',
      'feedback-ces',
      'feedback-weighted-score',
    ],
  },
];
